import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { GetInstituteInformation } from '../../../Actions/StudentA';
import { BaseUrl } from '../../../Actions/Base';
import AwardBadge from "../Assets/awardbadge.jpg"

const InstituteExcellenceAwarded = ({awards}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    return (
        <div className='w-full flex justify-center items-center mt-[50px]'>
            <div className='w-[90%] flex flex-col gap-[20px]'>
                <p className='text-[30px] font-bold text-center lg:text-left'>Excellence Rewarded</p>
                <div className='flex items-center flex-wrap gap-[40px] mt-[20px]'>
                    {awards.map((award) => (
                    <div key={award.AwardPK} className={`w-[360px] flex w-full p-[15px] rounded-[12px] shadow-[4px_5px_6px_#00000029] ${Border}`}>
                        <div className="w-[40%] justify-center items-center">
                            {/* <img className='w-[120px] h-[150px]' src={AwardBadge} alt="awardbadge" /> */}
                            <img  className='w-[120px] h-[150px]'
                                  src={`${BaseUrl}/api/vehicletype/image?url=${award?.AwardThumbnail}`} alt="Courseimg" />
                        </div>

                        <div className='w-[60%] flex flex-col gap-[20px]'>
                            <p className='text-[18px] font-bold text-[#2D2366]'>{award.Title}</p>
                            <p className='text-[18px] text-[#2D2366]'>{award.Description}</p>
                        </div>
                    </div>
                    ))}

                    
                </div>
            </div>
        </div>
    )
}

export default InstituteExcellenceAwarded